import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import '../../../../assets/css/customer/customerdashboard/customerLayout/customerdashboard.css';
import '../../../../assets/css/customer/customerdashboard/customerLayout/customersidebar.css';
import '../../../../assets/css/customer/customerdashboard/customerLayout/responsive.css';

const CustomerDashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleCollapse = (collapsed) => {
    setIsCollapsed(collapsed);
  };

  return (
    <div className={`cus-dashboard-container ${isCollapsed ? 'cus-sidebar-collapsed' : ''}`}>
      
      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
        onCollapse={handleCollapse}
      />

      {/* Main Content */}
      <div className="cus-main-content-wrapper">
        
        {/* Header */}
        <Header toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />

        {/* Page Content */}
        <div className="cus-dashboard-content-wrapper">
          <Outlet />
        </div>

      </div>
    </div>
  );
};

export default CustomerDashboardLayout;